// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Material Kit 2 React components
import TransparentBlogCard from 'examples/Cards/BlogCards/TransparentBlogCard';

import data from 'csdd_data/industryUpdates';

function IndustryUpdatesCompo() {
  return (
    <MKBox component='section' py={2}>
      <Container>
        <MKTypography textGradient variant='h2' mb={1} mt={1}>
          Industry Updates
        </MKTypography>
        <MKTypography variant='body1' color='text' mb={6}>
          Stay Informed, Stay Ahead.
        </MKTypography>
        {data.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            Industry updates are not available at the moment.
          </MKTypography>
        ) : (
          <Grid container spacing={3}>
            {data.map((update) => {
              return (
                <Grid item xs={12} sm={6} lg={4} key={update.href}>
                  <TransparentBlogCard
                    image={update.headerImage}
                    title={update.title}
                    action={{
                      type: 'external',
                      route: `${update.href}`,
                      color: 'error',
                      label: 'visit link',
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
      </Container>
    </MKBox>
  );
}

export default IndustryUpdatesCompo;
